import { ApiRequestError } from '@/api/client';

import { http } from '@/api/http';



interface StripeConfigResponse {

  data?: Record<string, unknown>;

  publishable_key?: string;

  publishableKey?: string;

  mode?: string;

}



interface StripeIntentResponse {

  data?: Record<string, unknown>;

  client_secret?: string;

  clientSecret?: string;

  payment_intent_id?: string;

  paymentIntentId?: string;

  final_price?: number | string;

}



interface ConfirmStripeResponse {

  data?: Record<string, unknown>;

  order_id?: number | string;

  orderId?: number | string;

  status?: number | string;

  payment_time?: string;

  paymentTime?: string;

}



export interface StripeConfig {

  publishableKey: string;

  mode: string;

}



/** POST `/system/subpayment/get_stripe_config` */

export async function fetchStripeConfig(): Promise<StripeConfig> {

  const res = await http.post<StripeConfigResponse>('/system/subpayment/get_stripe_config');

  const d = res.data && typeof res.data === 'object' ? res.data : (res as Record<string, unknown>);

  const key =

    (typeof d.publishable_key === 'string' && d.publishable_key.trim()) ||

    (typeof d.publishableKey === 'string' && d.publishableKey.trim()) ||

    '';

  if (!key) {

    throw new ApiRequestError('Stripe publishable key is not configured.');

  }

  return {

    publishableKey: key,

    mode: typeof d.mode === 'string' ? d.mode : 'test',

  };

}



export interface StripeIntentResult {

  clientSecret: string;

  paymentIntentId: string;

  finalPrice: number;

}



/** POST `/system/subpayment/create_stripe_intent` */

export async function postCreateStripeIntent(

  orderId: number | string,

): Promise<StripeIntentResult> {

  const res = await http.post<StripeIntentResponse>('/system/subpayment/create_stripe_intent', {

    order_id: orderId,

  });

  const d = res.data && typeof res.data === 'object' ? res.data : (res as Record<string, unknown>);

  const clientSecret =

    (typeof d.client_secret === 'string' && d.client_secret) ||

    (typeof d.clientSecret === 'string' && d.clientSecret) ||

    '';

  const paymentIntentId =

    (typeof d.payment_intent_id === 'string' && d.payment_intent_id) ||

    (typeof d.paymentIntentId === 'string' && d.paymentIntentId) ||

    '';

  if (!clientSecret) {

    throw new ApiRequestError('Stripe client secret missing in response.');

  }

  const finalPrice =

    typeof d.final_price === 'number'

      ? d.final_price

      : typeof d.final_price === 'string' && !Number.isNaN(Number(d.final_price))

        ? Number(d.final_price)

        : 0;

  return { clientSecret, paymentIntentId, finalPrice };

}



export interface ConfirmStripePaymentResult {

  orderId: number | string;

  status: number;

  paymentTime?: string;

}



/** POST `/system/subpayment/confirm_stripe_payment` */

export async function postConfirmStripePayment(

  orderId: number | string,

  paymentIntentId: string,

): Promise<ConfirmStripePaymentResult> {

  const res = await http.post<ConfirmStripeResponse>(

    '/system/subpayment/confirm_stripe_payment',

    {

      order_id: orderId,

      payment_intent_id: paymentIntentId,

    },

    { skipApiEnvelopeModal: true },

  );

  const d = res.data && typeof res.data === 'object' ? res.data : (res as Record<string, unknown>);

  const id = d.order_id ?? d.orderId ?? orderId;

  const status =

    typeof d.status === 'number'

      ? d.status

      : typeof d.status === 'string' && !Number.isNaN(Number(d.status))

        ? Number(d.status)

        : 1;

  return {

    orderId: id as number | string,

    status,

    paymentTime:

      typeof d.payment_time === 'string'

        ? d.payment_time

        : typeof d.paymentTime === 'string'

          ? d.paymentTime

          : undefined,

  };

}


